import { PlaceholderPage } from '@/components/molecules/PlaceholderPage';
import { useReportsPage } from './useReportsPage';

export function ReportsPage() {
  const { title, description } = useReportsPage();

  return <PlaceholderPage title={title} description={description} />;
}
